import React from 'react';
import nary from "./nary";
import { isPortrait, isLandscape } from "./commonMobile";
import { IRoadmapSmallClass } from "@/types/RoadmapSmallTypes";
import getRoadmapText from "./getRoadmapText";

function resetRoadmap(self: IRoadmapSmallClass, totalColumns: number) {
	self.firstDisplayedCol = 0;
	self.totalColumns = totalColumns;
}

function resetDisplayPointer(self: IRoadmapSmallClass) {
	self.currentDisplayRow = 0;
	self.currentDisplayCol = 0;
	self.currentType = "";
}

function addDisplayTile(displayAry: JSX.Element[][],
		tile: JSX.Element,
		type: string,
		mainClass: IRoadmapSmallClass) {
	// console.log("aDT", mainClass.currentType, type);
	
	const rowLimit = mainClass.props.lobbyMobile ? 4 : //Mobile Lobby
		mainClass.props.lobbyDesktop ? 6 : //Desktop Lobby (new)
		isLandscape() ? 4 : //Mobile landscape
		isPortrait() ? 4 : //Mobile portrait
		!mainClass.props.small ? 6 : //Desktop Lobby
		4; //Desktop Multi Table
	
	if (mainClass.currentType !== type ||
		mainClass.currentDisplayRow >= rowLimit - 1) {
		mainClass.currentDisplayRow = 0;
		mainClass.currentDisplayCol++;
	} else {
		mainClass.currentDisplayRow++;
	}
	
	displayAry[mainClass.currentDisplayRow][mainClass.currentDisplayCol] = tile;

	//nudge to the left on overflow
	if (mainClass.currentDisplayCol > mainClass.totalColumns) {
		// console.log("Overflow");
		mainClass.firstDisplayedCol = mainClass.currentDisplayCol - mainClass.totalColumns;
	}
	
	mainClass.currentType = type;
}



function getElementDiv(mainClass: IRoadmapSmallClass, styleArray: string[], idx: number, ary) {
	// "sl-roadmap-diamond sl-roadmap-red "
	return <div className={styleArray.map(item => "sl-roadmap-" + item + " ").join("") + checkHistoryBlink(mainClass, idx, ary)} />;
}

function checkHistoryBlink(mainClass: IRoadmapSmallClass, idx: number, ary) {
	const alternatingStyle = "sl-roadmap-alternating";
	const historyBlink = mainClass.props.historyBlink;
	return historyBlink && (idx === ary.length - 1) ? alternatingStyle : null;
}

function prepareRender(mainClass: IRoadmapSmallClass) {
	mainClass.roadmapArray = [];
	for (let a = 0; a < 9; a++)
		mainClass.roadmapArray[a] = [];
	
	resetRoadmap(mainClass, 10);
	
	resetDisplayPointer(mainClass);

	// mainClass.history = mainClass.props.history;
}

//Renders Roadmap for RoadmapSmall Components
//mainClass: the RoadmapSmall Component
function renderRoadmap(mainClass: IRoadmapSmallClass) {
	const moreColumns = ["m11", "m13", "m20"];
	const { pcode, filter, langdata } = mainClass.props;
	
	const hasMoreColumns = moreColumns.indexOf(pcode) >= 0;

	const roadmapColumns = (
		mainClass.props.showLobbyGameGroup ? (
			mainClass.props.orientation === "landscape" || isLandscape() ?
			nary(12) : nary(21)
		) :
		mainClass.props.lobbyMobile ?
			(
				isLandscape() ?
				(hasMoreColumns ? nary(12) : nary(11)) : //Mobile landscape
				(hasMoreColumns ? nary(12) : nary(10)) //Mobile portrait
			) :
		mainClass.props.mobile ? (
			hasMoreColumns ? nary(12) : nary(11) //Mobile
		) :
		mainClass.props.small ? (hasMoreColumns ? nary(11) : nary(10)) :
		(moreColumns.indexOf(pcode) >= 0) ? nary(14) : nary(13)
	);
	
	const roadmapRows = mainClass.props.lobbyMobile ? nary(4) : //Mobile Lobby
		mainClass.props.lobbyDesktop ? nary(6) : //Desktop Lobby (new)
		isLandscape() ? nary(4) : //Mobile landscape
		isPortrait() ? nary(4) : //Mobile portrait
		!mainClass.props.small ? nary(6) : //Desktop Lobby
		nary(4); //Desktop Multi Table
	
	const roadmapText = getRoadmapText(pcode, filter, langdata);

	// console.log(roadmapText);

	// Fills the roadmap with active data
	const roadmapTable = (
		<table className="lobby-roadmap-table">
			{
				mainClass.props.lobbyMobile ||
				mainClass.props.mobile ? (
					<thead>
						<tr>
							<td>
								{roadmapText}
							</td>
						</tr>
					</thead>
				) : null
			}

			<tbody>
			{
				roadmapRows.map(row => 
					<tr key={"row" + row}>
					{
						roadmapColumns.map(col =>
							(
								<td key={"col" + col}>
								{
									mainClass.roadmapArray[row - 1][col + mainClass.firstDisplayedCol] !== undefined ?
									mainClass.roadmapArray[row - 1][col + mainClass.firstDisplayedCol] : null
								}
								</td>
							)
						)
					}
					</tr>
				)
			}
			</tbody>
		</table>
	);
	
	return (
		<div className="roadmap">
			{ roadmapTable }
		</div>
	);
}

export {
	checkHistoryBlink,
	getElementDiv,
	prepareRender,
	renderRoadmap,
	
	resetRoadmap,
	resetDisplayPointer, 
	addDisplayTile
};